export const PLACEHOLDER_TURNOVER = 23750855.2;
export const PLACEHOLDER_PROFIT_LOSS = 7782750.7;
export const PLACEHOLDER_MARGIN = 33.5;

export const PLACEHOLDER_TOTAL_ROWS = 100;

export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100] as const;

export type PageSizeOption = (typeof PAGE_SIZE_OPTIONS)[number];

/** Default rows per page for the reporting summary table (matches API `limit`). */
export const DEFAULT_REPORTING_SUMMARY_PAGE_SIZE: PageSizeOption = 100;
